import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateRegistrationResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const associateRegistration = {
    record(data: typeof Requests.AssociateRegistration.Record.Input) {
        return post<typeof data, AssociateRegistrationResponseTypes.Record>(
            `/associate-registration/record`,
            data,
        );
    },
    signup(data: typeof Requests.AssociateRegistration.Signup.Input) {
        return post<typeof data>(`/associate-registration/signup`, data, { authenticated: false });
    },
    accept(id: string) {
        return postEmpty(`/associate-registration/accept/${id}`);
    },
    reject(id: string) {
        return postEmpty(`/associate-registration/reject/${id}`);
    },
    finalize(id: string, data: typeof Requests.AssociateRegistration.Finalize.Input) {
        return post<typeof data>(`/associate-registration/finalize/${id}`, data, {
            authenticated: false,
        });
    },
    obtain(id: string) {
        return get<AssociateRegistrationResponseTypes.Obtain>(
            `/associate-registration/obtain/${id}`,
        );
    },
    status(id: string) {
        return get<AssociateRegistrationResponseTypes.Status>(
            `/associate-registration/status/${id}`,
            { authenticated: false },
        );
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateRegistration.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate-registration/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
